import { render, staticRenderFns } from "./shop_money.vue?vue&type=template&id=85171dce&scoped=true"
import script from "./shop_money.vue?vue&type=script&lang=ts"
export * from "./shop_money.vue?vue&type=script&lang=ts"
import style0 from "./shop_money.vue?vue&type=style&index=0&id=85171dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85171dce",
  null
  
)

export default component.exports